import { useEffect, useState } from 'react'
import dayjs from 'dayjs'
dayjs.extend(require('dayjs/plugin/duration'))

export const useCountDown = (_count: number) => {
  const [count, setCount] = useState(_count)

  useEffect(() => {
    const timer = setInterval(() => {
      if (count > 0) {
        setCount(count => count - 1)
      } else {
        clearInterval(timer)
      }
    }, 1000)

    return () => {
      clearInterval(timer)
    }
  }, [count])

  // @ts-ignore
  const duration = dayjs.duration(count * 1000)
  const [days, hours, minutes, seconds] = [
    duration.asDays(),
    duration.hours(),
    duration.minutes(),
    duration.seconds(),
  ]

  const countdownStr = `${Math.floor(days) ? `${Math.floor(days)}天` : ''}${
    hours <= 9 ? `0${hours}` : hours
  }:${minutes <= 9 ? `0${minutes}` : minutes}:${
    seconds <= 9 ? `0${seconds}` : seconds
  }`

  return {
    days,
    hours,
    minutes,
    seconds,
    countdown: count,
    countdownStr,
  }
}
